<div class="analytics-details-view flex min-h-0 flex-1 flex-col">
  @switch (deliverableType()) {
    @case (EDeliverableType.title) {
      <app-title-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.chatBot) {
      <app-chatbot-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.chatbotMulti) {
      <app-chatbot-multi-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.talkingPoint) {
      <app-talking-point-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.talkingPointAi) {
      <app-talking-point-ai-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.audioTracking) {
      <app-audio-tracking-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.textTracking) {
      <app-text-tracking-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.gamePlay) {
      <app-game-play-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.visual) {
      <app-visual-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.showcase) {
      <app-showcase-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.productPlacement) {
      <app-product-placement-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
    @case (EDeliverableType.custom) {
      <app-custom-stream-analytics
        class="analytics-details-view__content"
        [deliverableForm]="deliverableForm()"
        [platform]="platform()"
        [deliverableId]="deliverableId()"
        [executionAnalytics]="executionAnalytics()"
        [timelineData]="store.timeline$()"
        [viewerGraphData]="preparedViewerGraphData()"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    }
  }

  <ng-content />
</div>
